import PageSeo from '@framework/seo/PageSeo';
import MetaSchema from '@/creditflowresearch/ui/common/components/MetaSchema';

interface IProps {
  title: string,
  description?: string,
  url?: string,
  schema?: any,
  isWithoutMerging?: boolean,
}

const PageMeta = ({ title, description, url, schema, isWithoutMerging = false }: IProps) => {
  return (
    <>
      <MetaSchema schema={ schema } isWithoutMerging={ isWithoutMerging } />
      <PageSeo title={ title } description={ description } url={ url } />
    </>
  );
};

export default PageMeta;
